import STRING from 'string'
let originParams = {}
let headers = {}

export const normalizeThemeMode = (value) => {
  return `${value || ''}`.toLowerCase() === 'dark' ? 'dark' : 'light'
}

const parseAppAgentParams = (userAgents) => {
  const jsonBlocks = userAgents.match(/\{[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g) || []
  let parsed = null

  jsonBlocks.forEach((block) => {
    try {
      const current = JSON.parse(block)
      if (!parsed) {
        parsed = current
        return
      }
      // App 偶发拼接两段 JSON，优先保留带 themeMode 的那段
      if (current.themeMode && !parsed.themeMode) {
        parsed = { ...parsed, ...current }
      }
    } catch (error) {
      console.warn('[getUserAgent] JSON parse failed:', error)
    }
  })

  if (parsed) return parsed

  try {
    return JSON.parse('{' + STRING(userAgents).between('{', '}').s + '}')
  } catch (error) {
    console.warn('[getUserAgent] fallback JSON parse failed:', error)
    return null
  }
}

export const getOrigin = function () {
  let userAgents = navigator.userAgent
  console.log('userAgents: ', userAgents)

  if (process.env.NODE_ENV === 'development') {
    //只允许再测试环境
    userAgents = 'userAgents:  FXEYE-BIB-IOS-WIKIFX{"wikistock":"ios","themeMode":"dark","email": "1300381123@qq.com","language":"zh-cn","userId":null,"wikinum":null,"falg":"https://img.tech002.com/flag/7d8833382673bab2/CN.png_wiki-template-global","phonecode":"0086","hasWhatsApp":false,"showname":"","LanguagePreference":"zh-CN","avatar":null,"countrycode":"156","twoCharCode":"CN","BasicData":"0,1832,14,366,0,369a5d10-c664-11ef-8949-05aa4e8160f7,0","navHeight":59.0, "pkgName":"test", "fxintl":1}'
    // 不用注释
  }
  if (userAgents.includes('FXEYE-BIB-IOS-WIKIFX') || userAgents.includes('FXEYE-BIB-ANDROID-WIKIFX') || userAgents.includes('WIKIBIT-BIB-IOS') || userAgents.includes('WIKIBIT-BIB-ANDROID')) {
    originParams = parseAppAgentParams(userAgents)
    if (!originParams) return headers
    originParams.language = originParams.language?.toLowerCase()
    console.log('originParams: ', originParams)
    let newArr = []
    if (originParams?.labels?.length > 0) {
      originParams?.labels.forEach((el) => {
        newArr.push({
          data: [
            {
              labelName: el
            }
          ]
        })
      })
    }

    if (originParams.language == 'zh-tw' || originParams.language == 'zh-hk') originParams.language = 'zh'
    headers =
      {
        language: originParams.language || 'zh-cn',
        userId: originParams.userId || null,
        countrycode: originParams.countrycode, // 数字code
        twoCharCode: originParams.twoCharCode, // 英语code
        wikinum: originParams.wikinum || null,
        falg: originParams.falg,
        phonecode: originParams.phonecode,
        myCountry: originParams.countrycode,
        LanguagePreference: originParams.LanguagePreference,
        BasicData: originParams.BasicData,
        navHeight: originParams.navHeight,
        nick: originParams?.nick || '',
        avatar: originParams?.avatar || '',
        countryName: originParams?.countryName || '',
        fxintl: originParams?.fxintl || '',
        ...originParams,
        themeMode: normalizeThemeMode(originParams.themeMode)
      } || {}
    console.log('[themeMode]', headers.themeMode, headers)
    console.log(headers, 'headers')
    console.log('userAgents::: ', userAgents)
    return headers
  }
}
